import { Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";
import Pencil from "../../../../../Assets/Icons/Admin panel/Pencil.svg";
import Delete from "../../../../../Assets/Icons/Admin panel/Delete.svg";
import Chat from "../../../../../Assets/Icons/Admin panel/Chat.svg";
import ImagePreloader from "./ImagePreloader";
import FailModal from "../../../../../Components/FailModal";

const UserManagementTableRow = (props) => {
  const [ContextMenuIsOpen, setContextMenuIsOpen] = useState(false);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);

  const toggleDelete = () => {
    setContextMenuIsOpen(false);
    setDeleteIsOpen(true);
  };

  const requestDeleteUser = () => {
    setDeleteIsOpen(false);
    props.ToggleDeleteUser(props.Item.id);
  };

  const swapType = (Profile) => {
    if (Profile === "ROLE_ADMIN") {
      return "Admin";
    } else {
      return "User";
    }
  };

  const displayName = () => {
    let Name = props.Item.fullName;
    if (Name) {
      if (Name.length <= 20) {
        return Name;
      } else {
        return Name.slice(0, 16) + "...";
      }
    } else {
      return "N/A";
    }
  };

  const displayUsername = () => {
    let Username = props.Item.email;
    if (Username) {
      if (Username.length <= 24) {
        return Username;
      } else {
        return Username.slice(0, 20) + "...";
      }
    } else {
      return "N/A";
    }
  };

  const formatDate = (dateString) => {
    // Parse the date string into a Date object
    const date = new Date(dateString);

    // Array of month names
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Extract the month, day, and year
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    // Format and return the date
    return `${month} ${day}, ${year}`;
  };

  return (
    <div className="table-row">
      <ImagePreloader Images={[Pencil, Delete, Chat]} />
      <FailModal
        reverse
        show={DeleteIsOpen}
        title={`Delete the user ${props.Item.email}`}
        description="Are you sure you want to delete this user? All weddings and collections belonging to the user will also be deleted."
        onCancel={() => setDeleteIsOpen(false)}
        onRetry={requestDeleteUser}
        retryText="Delete"
      />
      {ContextMenuIsOpen ? (
        <div
          className="outline"
          onClick={() => setContextMenuIsOpen(false)}
        ></div>
      ) : null}
      <div className="small">
        <FormControlLabel
          control={
            <Checkbox
              onChange={null}
              color="primary"
              sx={{
                "&.Mui-checked": {
                  color: "#FB4764", // Change color to purple when checked
                },
                marginRight: "-8px", // Reduce top margin
              }}
            />
          }
        />
      </div>
      <div className="medium">{displayUsername()}</div>
      <div className="medium name-filter">{displayName()}</div>
      <div className="medium profiles profile-filter">
        {props.Item.assignedProfiles.map((Profile, i) => (
          <div key={i}>{swapType(Profile)}</div>
        ))}
      </div>
      <div className="medium create-date">
        {props.Item.createdDate ? formatDate(props.Item.createdDate) : "N/A"}
      </div>
      <div className="medium profiles create-date">
        {props.Item.usedCredits
          ? props.Item.usedCredits?.toLocaleString("en-US")
          : 0}
      </div>
      <div className="medium profiles create-date">
        {props.Item.totalTokenUsed
          ? props.Item.totalTokenUsed?.toLocaleString("en-US")
          : 0}
      </div>
      <div className="medium status">
        <div
          className={props.Item.activated ? "circle" : "circle circle-inactive"}
        ></div>
        <p>{props.Item.activated ? "Active" : "Inactive"}</p>
      </div>
      <div
        className="context-menu-trigger"
        onClick={() => setContextMenuIsOpen(true)}
      ></div>
      {ContextMenuIsOpen ? (
        <section className="context-menu">
          <div className="context-menu-row" onClick={() => props.EditUser()}>
            <img src={Pencil} />
            <section className="menu-row-text">
              <p className="row-name">Edit</p>
              <p className="row-info">Edit user</p>
            </section>
          </div>
          <div
            className={
              props.LoggedinUser.id === props.Item.id
                ? "context-menu-row disabled"
                : "context-menu-row"
            }
            onClick={() => toggleDelete()}
          >
            <img
              src={Delete}
              style={
                props.LoggedinUser.id === props.Item.id
                  ? { opacity: "0.5" }
                  : {}
              }
            />
            <section className="menu-row-text">
              <p className="row-name">Delete</p>
              <p className="row-info">Delete user permenantly</p>
            </section>
          </div>
          <div className="context-menu-row disabled">
            <img src={Chat} />
            <section className="menu-row-text">
              <p className="row-name">Message</p>
              <p className="row-info">Send message</p>
            </section>
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default UserManagementTableRow;
